import { render, staticRenderFns } from "./BtnExcluirCronogramaRecebimento.vue?vue&type=template&id=1761be52&"
import script from "./BtnExcluirCronogramaRecebimento.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirCronogramaRecebimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports